import request from '@/util/request';

//获取数据
export const getFeePayByPaybillNo = (params, options) =>
request.get('/api/v4ward/invoice/get-fee-pay', Object.assign({}, options, { params }));
